module.exports = __webpack_public_path__ + "img/food_pin.190f4348.png";